import script from "./share.modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./share.modal.vue?vue&type=script&lang=ts&setup=true"

import "./share.modal.vue?vue&type=style&index=0&id=a12a1244&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a12a1244"]])

export default __exports__